
    <template>
      <section class="relax-doc">
        <h1>Steps 步骤条</h1>
<blockquote>
<p>一步两步，一步两步；一步一步似爪牙，是魔鬼的步伐</p>
</blockquote>
<h2 id="yan-shi"><a class="header-anchor" href="#yan-shi"></a> 演示</h2>
<blockquote>
<p>简单的步骤条</p>
</blockquote>
<demo-block>
        
        <template #source><element-demo0 /></template>
        <template #highlight><pre v-pre><code class="html">&lt;template&gt;
  &lt;x-steps :current=&quot;active&quot;&gt;
    &lt;x-step title=&quot;第一步&quot; description=&quot;打开微信扫一扫&quot; /&gt;
    &lt;x-step title=&quot;第二步&quot; description=&quot;添加好友&quot; /&gt;
    &lt;x-step title=&quot;第三步&quot; description=&quot;选择我的头像&quot; /&gt;
    &lt;x-step title=&quot;第四步&quot; description=&quot;转款1000万&quot; /&gt;
  &lt;/x-steps&gt;

  &lt;x-button type=&quot;primary&quot; plain @click=&quot;onNext&quot; style=&quot;margin-top: 30px&quot;&gt;下一步&lt;/x-button&gt;
&lt;/template&gt;

&lt;script&gt;
  import { ref } from 'vue';
  export default {
    setup(){
      const active = ref(2);

      const onNext = () =&gt; {
        if (active.value++ &gt; 3) active.value = 0;
      }

      return {
        active,
        onNext
      }
    }
  }
&lt;/script&gt;
</code></pre></template></demo-block><h2 id="mo-ren-cha-cao"><a class="header-anchor" href="#mo-ren-cha-cao"></a> 默认插槽</h2>
<blockquote>
<p>插槽里放你想放的东西</p>
</blockquote>
<demo-block>
        
        <template #source><element-demo1 /></template>
        <template #highlight><pre v-pre><code class="html">&lt;template&gt;
  &lt;x-steps :current=&quot;3&quot;&gt;
    &lt;x-step&gt;第一步&lt;/x-step&gt;
    &lt;x-step&gt;第二步&lt;/x-step&gt;
    &lt;x-step&gt;第三步&lt;/x-step&gt;
    &lt;x-step&gt;第四步&lt;/x-step&gt;
  &lt;/x-steps&gt;
&lt;/template&gt;
</code></pre></template></demo-block><h2 id="zi-ding-yi-icon"><a class="header-anchor" href="#zi-ding-yi-icon"></a> 自定义Icon</h2>
<blockquote>
<p>可以放自己喜欢的图标啦</p>
</blockquote>
<demo-block>
        
        <template #source><element-demo2 /></template>
        <template #highlight><pre v-pre><code class="html">&lt;template&gt;
  &lt;x-steps :current=&quot;1&quot;&gt;
    &lt;x-step icon=&quot;x-icon-headphones&quot;&gt;听听歌&lt;/x-step&gt;
    &lt;x-step icon=&quot;x-icon-sun&quot;&gt;晒晒太阳&lt;/x-step&gt;
    &lt;x-step icon=&quot;x-icon-flag&quot;&gt;成啦&lt;/x-step&gt;
  &lt;/x-steps&gt;
&lt;/template&gt;
</code></pre></template></demo-block>
      </section>
    </template>
    <script>
      import hljs from 'highlight.js'
      import * as Vue from "vue"
      export default {
        name: 'component-doc',
        components: {
          "element-demo0": (function() {
    
    const { resolveComponent: _resolveComponent, createVNode: _createVNode, withCtx: _withCtx, createTextVNode: _createTextVNode, Fragment: _Fragment, openBlock: _openBlock, createElementBlock: _createElementBlock } = Vue

function render (_ctx, _cache) {
  const _component_x_step = _resolveComponent("x-step")
  const _component_x_steps = _resolveComponent("x-steps")
  const _component_x_button = _resolveComponent("x-button")

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_x_steps, { current: _ctx.active }, {
      default: _withCtx(() => [
        _createVNode(_component_x_step, {
          title: "第一步",
          description: "打开微信扫一扫"
        }),
        _createVNode(_component_x_step, {
          title: "第二步",
          description: "添加好友"
        }),
        _createVNode(_component_x_step, {
          title: "第三步",
          description: "选择我的头像"
        }),
        _createVNode(_component_x_step, {
          title: "第四步",
          description: "转款1000万"
        })
      ]),
      _: 1
    }, 8, ["current"]),
    _createVNode(_component_x_button, {
      type: "primary",
      plain: "",
      onClick: _ctx.onNext,
      style: {"margin-top":"30px"}
    }, {
      default: _withCtx(() => [
        _createTextVNode("下一步")
      ]),
      _: 1
    }, 8, ["onClick"])
  ], 64))
}
  
    
        const { ref } = Vue
        ;
  const democomponentExport = {
    setup(){
      const active = ref(2);

      const onNext = () => {
        if (active.value++ > 3) active.value = 0;
      }

      return {
        active,
        onNext
      }
    }
  }
    return {
      mounted(){
        this.$nextTick(()=>{
          const blocks = document.querySelectorAll('pre code:not(.hljs)')
          Array.prototype.forEach.call(blocks, hljs.highlightBlock)
        })
      },
      render,
      ...democomponentExport
    }
  })(),"element-demo1": (function() {
    
    const { createTextVNode: _createTextVNode, resolveComponent: _resolveComponent, withCtx: _withCtx, createVNode: _createVNode, openBlock: _openBlock, createBlock: _createBlock } = Vue

function render (_ctx, _cache) {
  const _component_x_step = _resolveComponent("x-step")
  const _component_x_steps = _resolveComponent("x-steps")

  return (_openBlock(), _createBlock(_component_x_steps, { current: 3 }, {
    default: _withCtx(() => [
      _createVNode(_component_x_step, null, {
        default: _withCtx(() => [
          _createTextVNode("第一步")
        ]),
        _: 1
      }),
      _createVNode(_component_x_step, null, {
        default: _withCtx(() => [
          _createTextVNode("第二步")
        ]),
        _: 1
      }),
      _createVNode(_component_x_step, null, {
        default: _withCtx(() => [
          _createTextVNode("第三步")
        ]),
        _: 1
      }),
      _createVNode(_component_x_step, null, {
        default: _withCtx(() => [
          _createTextVNode("第四步")
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
  
    const democomponentExport = {}
    return {
      mounted(){
        this.$nextTick(()=>{
          const blocks = document.querySelectorAll('pre code:not(.hljs)')
          Array.prototype.forEach.call(blocks, hljs.highlightBlock)
        })
      },
      render,
      ...democomponentExport
    }
  })(),"element-demo2": (function() {
    
    const { createTextVNode: _createTextVNode, resolveComponent: _resolveComponent, withCtx: _withCtx, createVNode: _createVNode, openBlock: _openBlock, createBlock: _createBlock } = Vue

function render (_ctx, _cache) {
  const _component_x_step = _resolveComponent("x-step")
  const _component_x_steps = _resolveComponent("x-steps")

  return (_openBlock(), _createBlock(_component_x_steps, { current: 1 }, {
    default: _withCtx(() => [
      _createVNode(_component_x_step, { icon: "x-icon-headphones" }, {
        default: _withCtx(() => [
          _createTextVNode("听听歌")
        ]),
        _: 1
      }),
      _createVNode(_component_x_step, { icon: "x-icon-sun" }, {
        default: _withCtx(() => [
          _createTextVNode("晒晒太阳")
        ]),
        _: 1
      }),
      _createVNode(_component_x_step, { icon: "x-icon-flag" }, {
        default: _withCtx(() => [
          _createTextVNode("成啦")
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
  
    const democomponentExport = {}
    return {
      mounted(){
        this.$nextTick(()=>{
          const blocks = document.querySelectorAll('pre code:not(.hljs)')
          Array.prototype.forEach.call(blocks, hljs.highlightBlock)
        })
      },
      render,
      ...democomponentExport
    }
  })(),
        }
      }
    </script>
  